<template>
  <table v-if="section.items.length" class="table">
    <thead class="thead-light">
      <tr>
        <th v-for="(columnName, fieldKey) in section.index_table.columns" :key="`th-${uniqueId}-${fieldKey}`" scope="col">
          {{ columnName }}
        </th>
        <th v-if="section.index_table.actions.length"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, itemIndex) in section.items" :key="`tr-${uniqueId}-${itemIndex}`">
        <td v-for="(columnName, fieldKey) in section.index_table.columns" :key="`td-${uniqueId}-${itemIndex}-${fieldKey}`" scope="col">
          {{ getItemlValue(item, fieldKey) }}
        </td>
        <td v-if="section.index_table.actions.length">
          <div class="d-flex w-100 justify-content-end align-items-center">
            <i
              v-for="action in section.index_table.actions"
              :key="`action-${action}`"
              :class="[getActionIcon(action)]"
              class="d-block ml-2"
              style="cursor: pointer"
              @click="emitAction(action, itemIndex)"
            ></i>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div v-else>
    <div>Nessun elemento inserito</div>
  </div>
</template>

<script>
import uniqid from "uniqid";

export default {
  props: ["section"],

  data() {
    return {
      uniqueId: uniqid(),
    };
  },

  watch: {
    section: {
      deep: true,
      handler: function () {
        this.uniqueId = uniqid();
      },
    },
  },

  methods: {
    getItemlValue(item, fKey) {
      let field = null;
      item.forEach((g) => {
        const fieldResult = g.fields.find((i) => i.fieldKey == fKey);
        if (fieldResult) field = fieldResult;
      });

      if (field.type == "collection") {
        return field.items.length;
      }

      if (field.type == "select") {
        return field.options[field.value];
      }

      return field.value;
    },

    getActionIcon(action) {
      return {
        edit: "tio-visible",
        delete: "tio-delete",
      }[action];
    },
    emitAction(action, itemIndex) {
      this.$emit("action", action, itemIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}
</style>
